import { Injectable } from '@angular/core';
import { Observable, from, map, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { BaseGooglePayService } from './base-google-pay.service';

import * as Mappers from '@shared/core/mappers/paymentProviders';

@Injectable({
    providedIn: 'root',
})
export class WindcaveGooglePayService extends BaseGooglePayService {
    public pay(totalPrice: string): Observable<Nullable<OLO.DTO.GooglePayPaymentData>> {
        if (!this._instance) {
            console.error('Google Pay instance not initialized');

            return of(null);
        }

        return from(this._instance.loadPaymentData(this._generatePaymentDataRequestObj(totalPrice))).pipe(
            map((paymentData) => Mappers.GooglePayPaymentProviderMapper.mapDirectResponseToPayData(paymentData?.paymentMethodData)),
            catchError((err) => {
                console.error('Google pay payment error:', err);

                return of(null);
            }),
        );
    }

    protected _generatePaymentDataRequestObj(totalPrice: string): google.payments.api.PaymentDataRequest {
        return {
            ...(this._readyToPayRequest as google.payments.api.PaymentDataRequest),
            allowedPaymentMethods: this._readyToPayRequest.allowedPaymentMethods.map((paymentMethod) => ({
                ...paymentMethod,
                tokenizationSpecification: {
                    type: 'PAYMENT_GATEWAY',
                    parameters: {
                        gateway: 'windcave',
                        gatewayMerchantId: this._config.payments.googlePay.gatewayMerchantId,
                    },
                },
            })),
            transactionInfo: {
                totalPrice,
                totalPriceStatus: 'FINAL' as google.payments.api.TotalPriceStatus,
                countryCode: this._config.localization.country,
                currencyCode: this._config.localization.currency || 'AUD',
            },
            merchantInfo: {
                merchantId: this._config.payments.googlePay.gatewayMerchantId,
                merchantName: this._config.payments.googlePay.merchantName ?? null,
            },
        };
    }
}
